import * as classNames from "classnames"

interface Props {
    value: string
    onChange: (value: any) => void
    isTextAreaBlank: boolean
    textAreaData: any
    borderColor:string
    isChecked: boolean
}
export class TextArea extends React.Component<Props, State> {

    render() {
        const { value, onChange, isTextAreaBlank, textAreaData, isChecked , borderColor} = this.props
        return (
            <div id="RedMailTextAreaElement" className="RedMailTextArea">
                <div className="redMailTextAreaTop">
                    <p className="TextAreaHeadline">{textAreaData.textAreaHeadline}</p>
                 
                    {isChecked &&
                        <div className="shareButtonsWrapper">
                            <a href="https://wa.me/972548243550" className="whatsappButton" target="_blank">
                                <img />
                                <div>Whatsapp</div>
                            </a>
                            <a href="https://t.me/ynetTbot" className="telegramButton" target="_blank">
                                <img />
                                <div>Telegram</div>
                            </a>
                        </div>
                    }
                </div>
                <div className="textAreaWrapper">
                <div>{textAreaData.textAreaHeadlineShareButtonsActiveSecondLine}</div>
                    <textarea style={{borderColor:borderColor}} dir="rtl" placeholder={textAreaData.placeholder} value={value} onChange={(e) => onChange(e)} required className={classNames("textAre", { "placeholderErrorStyle": isTextAreaBlank })}></textarea>
                </div>
            </div>
        )
    }
}